import { CellBox } from "./CellBox";
import { formatTransactionCurrency } from "../../logic/currency-logic";
import { isNegative } from "../../logic/money";
import type { CurrencyFormat, Money } from "../../api/types";

export type AmountCellProps = {
  /// Null renders an empty cell (a transaction without a foreign amount).
  money: Money | null;
  currencyFormat: CurrencyFormat;
  pending: boolean;
};

/// Negatives are coloured like Monthly Summary's expense column, so the two
/// views agree on what an outgoing amount looks like.
export const AmountCell = ({
  money,
  currencyFormat,
  pending,
}: AmountCellProps) => (
  <CellBox
    pending={pending}
    sx={{
      justifyContent: "flex-end",
      whiteSpace: "nowrap",
      color: money && isNegative(money) ? "error.main" : undefined,
    }}
  >
    {money ? formatTransactionCurrency(money, currencyFormat) : ""}
  </CellBox>
);
